/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/* eslint-env browser */

import get from 'lodash/get';
import isString from 'lodash/isString';

import CommunicatorCommand from '../command/communicator-command';
import ErrorLevel from '../../error/error-level';

/**
 * Komunikátor front příkazů zařízení pro Ki-Wi Server.
 */
class CommunicatorQueue {
  /**
   * Doručí příkaz z fronty příkazů zařízení.
   * @param {string} queueId Identifikátor fronty.
   * @param {string} deviceId Identifikátor Ki-Wi zařízení, které chce komunikovat.
   * @param {string} serverUrl URL adresa Ki-Wi Server pro komunikaci.
   * @returns {Promise.<CommandEnum>} Příkaz pro zařízení.
   */
  fetch(queueId, deviceId, serverUrl) {
    if (!isString(queueId)) {
      throw new TypeError('Missing queueId.');
    }
    return (
      fetch(`${serverUrl}/api/device/${deviceId}/queue/${queueId}`, {
        method: 'POST'
      })
        // Snížení priority logování pro chyby síťového spojení.
        .catch((error) => {
          error.level = ErrorLevel.Warning;
          throw error;
        })
        .then((response) => {
          // Snížení priority logování pro chyby ze serveru.
          if (!response.ok) {
            const error = new RangeError(
              `Invalid HTTP status "${response.status}".`
            );
            error.level = ErrorLevel.Warning;
            throw error;
          }
          return response.json();
        })
        .then((json) => CommunicatorQueue.parse(json))
    );
  }

  /**
   * Zpracuje frontu příkazů zařízení.
   * @param {Object} [json] Odpověď na frontu příkazů zařízení.
   * @returns {CommandEnum|null} Příkaz pro zařízení.
   */
  static parse(json) {
    return CommunicatorCommand.parse(get(json, 'command'));
  }
}

export default CommunicatorQueue;
